import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getKeywordById, siteName, keywords as allKeywords } from './keywords'; // Import helper and siteName

function KeywordPage() {
  // useParams hook from react-router-dom to get URL parameters
  const { keywordId } = useParams();
  const keyword = getKeywordById(keywordId);

  useEffect(() => {
    if (keyword) {
      // Set the document title dynamically for SEO
      document.title = `${keyword.name} | Szczegóły kebaba | ${siteName}`;
    } else {
      document.title = `Nie znaleziono kebaba | ${siteName}`;
    }
    // Scroll to top when component mounts or keywordId changes
    window.scrollTo(0, 0);
  }, [keywordId, keyword]); // Rerun effect if keywordId or keyword object changes

  if (!keyword) {
    return (
      <div className="keywords-container"> {/* Reusing the class */}
        <h1>Nie znaleziono kebaba</h1>
        <p>kebab, którego szukasz ("{keywordId}") nie został znaleziony.</p>
        <p>Sprawdź inne kebaby</p>
        <ul>
          {allKeywords.map((kw) => (
            <li key={kw.id}>
              <Link to={`/kebab/${kw.id}`}>{kw.name}</Link>
            </li>
          ))}
        </ul>
        <Link to="/" style={{ marginTop: '20px', display: 'inline-block' }}>Back to All kebabs</Link>
      </div>
    );
  }

  return (
    <div className="keywords-container"> {/* Reusing the class */}
      <h1>{keyword.name}</h1>
      <p>{keyword.description}</p>
      {/* You can add more specific content related to the keyword here */}
      <div style={{ marginTop: '30px' }}>
        <Link to="/">← Wróć do listy kebabów</Link>
      </div>
    </div>
  );
}

export default KeywordPage;
